import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '../index';

import * as MajorActions from './major.actions';
import * as MajorSelectors from './major.selectors';
import { MajorModel } from '@cpd-app/core-module/models';

@Injectable({
  providedIn: 'root'
})
export class MajorFacade {
  searchResultModel$ = this.store.pipe(
    select(MajorSelectors.getSearchResultModel)
  );
  occupationList$ = this.store.pipe(select(MajorSelectors.getOccupationList));

  constructor(private store: Store<AppState>) {}

  setMajor(majorModel: MajorModel) {
    this.store.dispatch(MajorActions.removeMajor());
    this.store.dispatch(MajorActions.setMajor({ majorModel }));
  }

  removeMajor() {
    this.store.dispatch(MajorActions.removeMajor());
  }
}
